interface EmptyStateProps {
  message?: string;
}

export function EmptyState({ message = "No items found" }: EmptyStateProps) {
  return (
    <div className="rounded-xl border-2 border-dashed border-[#2a475e] bg-[#16202d] p-12 text-center">
      <p className="text-[#8f98a0]">{message}</p>
    </div>
  );
}

